<style scoped lang="less">
@import 'modal.less';

.modal-item {
  .modal-item-base();
}
</style>
<template>
  <Modal
    v-model="vis"
    :loading="true"
    :mask-closable="false"
    :title="$t('设置资金密码')"
  >
    <el-form ref="formRef" :model="formData" :rules="rules">
      <div class="tips">
        <span>{{ $t('新资金密码') }}</span>
        <el-tooltip effect="dark" content="6位纯数字" placement="bottom">
          <i class="el-icon-warning" style="margin-left:5px"></i>
        </el-tooltip>
      </div>
      <el-form-item prop="password">
        <el-input
          v-model.trim="formData.password"
          type="password"
          size="large"
          show-password
          :placeholder="$t('请输入新密码')"
        />
      </el-form-item>

      <div class="tips">{{ $t('新资金密码确认') }}</div>
      <el-form-item prop="password1">
        <el-input
          v-model.trim="formData.password1"
          type="password"
          size="large"
          show-password
          :placeholder="$t('请再次输入密码')"
        />
      </el-form-item>

      <el-form-item prop="code">
        <div class="tips">
          <span>
            {{ codeText }}
          </span>
          <i
            v-if="userInfo.email && userInfo.phone"
            class="el-icon-sort"
            @click="trigger = !trigger"
          ></i>
        </div>
        <div class="code-box">
          <el-input
            v-model.trim="formData.code"
            size="large"
            :placeholder="codePlaceholder"
          />
          <verify-code :rebase="vis" @click="getCode"></verify-code>
        </div>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="vis = false">{{ $t('取消') }}</el-button>
      <el-button type="primary" :loading="loading" @click="updateFundPass">
        {{ $t('确定') }}
      </el-button>
    </template>
  </Modal>
</template>

<script>
import ModalBase from '@/components/ModalBase'
import { ajax_sendSms, ajax_setFundPass } from '@/api/personal'
import { ajaxSmsHandle, updateUserInfo } from '@/utils'
import { mapState } from 'vuex'

export default {
  name: 'FundPassModal',
  extends: ModalBase,
  // props: {
  //   from: String
  // },
  data() {
    const codeValidator = (_, val, cb) => {
      if (!val) {
        cb(new Error(this.codeErrMsg))
      }
      cb()
    }
    const passwordValidator = (_, val, cb) => {
      if (!val) {
        cb(new Error(this.$t('请输入新密码')))
      }
      cb()
    }
    const password1Validator = (_, val, cb) => {
      if (!val) {
        cb(new Error(this.$t('请再次输入密码')))
      }
      if (val !== this.formData.password) {
        cb(new Error(this.$t('两次密码输入不一致')))
      }
      cb()
    }
    return {
      trigger: false,
      formData: {
        password: '',
        password1: '',
        code: ''
      },
      rules: {
        password: [
          {
            trigger: 'blur',
            validator: passwordValidator
          }
        ],
        password1: [
          {
            trigger: 'blur',
            validator: password1Validator
          }
        ],
        code: [
          {
            trigger: 'blur',
            validator: codeValidator
          }
        ]
      }
    }
  },
  computed: {
    ...mapState(['userInfo']),
    // 验证码类型 1 手机 2 邮箱
    nick() {
      if (this.userInfo.isPhone) {
        return this.trigger ? 2 : 1
      } else {
        return this.trigger ? 1 : 2
      }
    },
    // 验证码文案
    codeText() {
      return { 1: this.$t('短信验证码'), 2: this.$t('邮箱验证码') }[this.nick]
    },
    // 验证码placeholder
    codePlaceholder() {
      return { 1: this.$t('请输入短信验证码'), 2: this.$t('请输入邮箱验证码') }[
        this.nick
      ]
    },
    // 验证码placeholder
    codeErrMsg() {
      return {
        1: this.$t('请填写手机验证码！'),
        2: this.$t('请填写邮箱验证码！')
      }[this.nick]
    }
  },
  methods: {
    getCode(e) {
      ajaxSmsHandle(
        ajax_sendSms({
          type: 'updateTradePassword',
          nick: this.nick
        }),
        e
      )
    },
    async updateFundPass() {
      await this.$refs.formRef.validate()
      this.loading = true
      try {
        const { password1: _, ...params } = this.formData
        params.nick = this.nick
        await ajax_setFundPass(params)
        this.$Message.success(this.$t('操作成功'))
        await updateUserInfo()
        this.vis = false
        this.loading = false
        // if (this.from) {
        //   this.$router.back()
        // }
      } catch {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.tips {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  margin-bottom: 10px;
  .el-icon-sort {
    transform: rotate(90deg);
    cursor: pointer;
  }
}
.code-box {
  display: flex;
  .el-input {
    margin-right: 10px;
  }
}
</style>
